module.exports = "/assets/0a70c993840f7eb688fc9e575e4d2612.png";